import React, { useState, useEffect } from "react";
import axios from "../../api/axios.js";
import { getFetchOptions } from "../../js/utility.js";
import Breadcrumb from "../utils/Breadcrumb.jsx";

const ProfileLayout = () => {
  const [userData, setUserData] = useState([]);

  const rolesOptions = [
    {
      name: "Insegnante",
      value: "Insegnante",
    },
    {
      name: "Admin",
      value: "Admin",
    },
  ];

  const breadcrumb = {
    current_section: "Profilo",
    sections: [{ name: "Profilo", route_name: null, params: [] }],
  };

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${
            axios.defaults.baseBFFUrl
          }/fe/getUserData?userId=${localStorage.getItem("userId")}`,
          fetchOptions
        );
        const result = await response.json();
        if (result) {
          setUserData(result);
        } else {
          console.error("Error fetching user data");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchUserData();
  }, []);

  const isValidCF = (cf) => {
    if (!cf) return false;
    const regex = /^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z]$/i;
    return regex.test(cf);
  };

  // Stato per gestire l'errore del codice fiscale
  const [cfError, setCfError] = useState("");

  const isValidEmail = (email) => {
    if (!email) return false;
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };
  const [emailError, setEmailError] = useState("");

  // Modifica handleSave per controllare il codice fiscale
  const handleSaveWithCFCheck = async () => {
    let hasError = false;

    if (!isValidCF(userData.cf)) {
      setCfError("Codice fiscale non valido");
      hasError = true;
    } else {
      setCfError("");
    }

    if (!isValidEmail(userData.email)) {
      setEmailError("Email non valida");
      hasError = true;
    } else {
      setEmailError("");
    }

    if (!userData.nominativo) {
      alert("Il campo Nominativo è obbligatorio.");
      hasError = true;
    }

    if (hasError) return;

    await handleSave();
  };

  const handleSave = async () => {
    const fetchOptions = getFetchOptions(
      "application/json",
      { adminId: userData.id, adminData: userData },
      "PUT"
    );
    await fetch(
      `${axios.defaults.baseBFFUrl}/fe/updateAdmin`,
      fetchOptions
    ).then(() => {
      window.location = "/profile";
    });
  };

  return (
    <div className="container-fluid">
      <Breadcrumb breadcrumb={breadcrumb} />

      <div className="card custom-card">
        <div className="card-header card-title">Profilo</div>
        <div className="card-body">
          <div className="card custom-card">
            <div className="card-header">Dati generali</div>
            <div className="card-body">
              <div className="row mb-3">
                <div className="col-6">
                  <label htmlFor="annoscolastico">Anno Scolastico</label>
                  <input
                    id="annoscolastico"
                    name="annoscolastico"
                    type="text"
                    className="form-control"
                    value={
                      userData.annoscolastico
                        ? userData.annoscolastico.replace(
                            /^(\d{4})(\d{4})$/,
                            "$1/$2"
                          )
                        : ""
                    }
                    readOnly
                    disabled
                  />
                </div>
                <div className="col-6">
                  <label htmlFor="ruolo">Ruolo</label>
                  <input
                    id="ruolo"
                    name="ruolo"
                    type="text"
                    className="form-control"
                    value={userData.ruolo || ""}
                    readOnly
                    disabled
                  />
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-6">
                  <label htmlFor="nominativo">
                    Nominativo <b>*</b>
                  </label>
                  <input
                    id="nominativo"
                    name="nominativo"
                    type="text"
                    className="form-control"
                    value={userData.nominativo || ""}
                    onChange={(e) => {
                      setUserData({ ...userData, nominativo: e.target.value });
                    }}
                  />
                </div>
                <div className="col-6">
                  <label htmlFor="email">
                    Email <b>*</b>
                  </label>
                  <input
                    className={`form-control ${emailError ? "is-invalid" : ""}`}
                    id="email"
                    name="email"
                    label="Email"
                    value={userData.email || ""}
                    onChange={(e) => {
                      setUserData({ ...userData, email: e.target.value });
                      if (emailError) setEmailError("");
                    }}
                  />
                  {emailError && (
                    <div className="invalid-feedback">{emailError}</div>
                  )}
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-6">
                  <label htmlFor="cf">
                    Codice Fiscale <b>*</b>
                  </label>
                  <input
                    className={`form-control ${cfError ? "is-invalid" : ""}`}
                    id="cf"
                    name="cf"
                    label="Codice fiscale"
                    value={userData.cf || ""}
                    onChange={(e) => {
                      setUserData({ ...userData, cf: e.target.value });
                      if (cfError) setCfError("");
                    }}
                  />
                  {cfError && <div className="invalid-feedback">{cfError}</div>}
                </div>
                <div className="col-6">
                  <label htmlFor="telefono">Telefono</label>
                  <input
                    id="telefono"
                    name="telefono"
                    type="number"
                    className="form-control"
                    value={userData.telefono || ""}
                    onChange={(e) => {
                      setUserData({ ...userData, telefono: e.target.value });
                    }}
                  />
                </div>
              </div>

              {/* <div className="row mb-3">
                {userData.ruolo === "Insegnante" && (
                  <div className="col-6">
                    <label htmlFor="materia">Materia</label>
                    <input
                      id="materia"
                      name="materia"
                      type="text"
                      className="form-control"
                      value={userData.materia || ""}
                      readOnly
                      disabled
                    />
                  </div>
                )}
              </div> */}
              <div className="saveButtonContainer">
                <div
                  id="saveTeacherBtn"
                  name="saveTeacherBtn"
                  className="btn btn-success saveButton"
                  role="button"
                  onClick={handleSaveWithCFCheck}
                >
                  {" "}
                  Salva{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileLayout;
